import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { languageChange } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const TOPIC_PCR_TEST = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  QUERY_CONFIG_REQUEST: null,
  QUERY_CONFIG_SUCCESS: null,
}, 'TOPIC_PCR_TEST')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    return dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          category: 'PCRTEST',
          size: 100,
          ...data
        },
        endpoint: '/cgs/api/personal/queryStoreList',
        requestAction: TOPIC_PCR_TEST.INIT_REQUEST,
        successAction: TOPIC_PCR_TEST.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function queryConfig() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/cmsii/v1/app/configurationItem',
        method: 'POST',
        body: {
          itemKey: 'MTOPAY_TOPIC_PCR_TEST_BANNER',
        },
        requestAction: TOPIC_PCR_TEST.QUERY_CONFIG_REQUEST,
        successAction: TOPIC_PCR_TEST.QUERY_CONFIG_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TOPIC_PCR_TEST.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [TOPIC_PCR_TEST.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [TOPIC_PCR_TEST.QUERY_CONFIG_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [TOPIC_PCR_TEST.QUERY_CONFIG_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'topicPcrTest',
    reducerMap: {
      topicPcrTestState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [languageChange('en')],
    // finalActions: []
  }
}
